// extracted by mini-css-extract-plugin
module.exports = {"author":"Author-module--author--6Yn76","author__bio-twitter":"Author-module--author__bio-twitter--3u3C-"};